import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContextProvider";
import { getDocumentaleLanguagePath } from "../i18n";
import { ArrowUpRightIcon } from "./ArrowUpRightIcon";
import Loader from "./Loader";
import { env } from "../lib/env";
import { ProductMarket } from "../@types/product";

export function ProductCard() {
    const { t, i18n } = useTranslation();
    const { state } = useContext(AppContext);
    const { product } = state;
    const { seriale, modello, codice_articolo, immagine, markets } = product;
    const canRegisterWarranty = markets?.includes(ProductMarket.IT_IT) ?? false;
    const portalLang = getDocumentaleLanguagePath(i18n.resolvedLanguage ?? i18n.language);
    const warrantyUrl = new URL(`${env.REACT_APP_DOCUMENTALE_URL}/${portalLang}/certificati/nuovo-certificato`);
    const qrParams = new URLSearchParams(window.location.search);
    const pin = qrParams.get("pin");

    if (seriale) {
        warrantyUrl.searchParams.set("sn", seriale);
    }

    if (pin) {
        warrantyUrl.searchParams.set("pin", pin);
    }

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        document.title = `${product.modello} - ${product.seriale} | Cosmogas LP`;
    }, [])

    const handleLoading = () => {
        setIsLoading(false);
    }

    return (
        <div className="flex flex-col md:flex-row w-full md:w-fit items-centers md:min-w-[550px] gap-[62px] border md:justify-center bg-white p-8 md:px-[56px] md:py-[32px] rounded-lg border-gray-200">
            {immagine &&
                <>
                    {isLoading && <Loader />}
                    <img
                        src={immagine}
                        onLoad={() => handleLoading()}
                        onError={() => handleLoading()}
                        className={`${isLoading ? "hidden" : ""} max-h-[210px] object-contain`}
                    />
                </>
            }
            <div className="flex flex-col items-start justify-center w-fit md:max-w-[70%]">
                <h1 className="text-gray-900 text-[30px] font-bold">{modello}</h1>
                <h2 className="text-gray-900 text-[24px]">{seriale}</h2>
                <div className="flex gap-2 text-gray-400 pt-2 text-[18px]">
                    <h3 className="text-nowrap font-bold">{t("modelNumber")}</h3>
                    <h3>{codice_articolo}</h3>
                </div>
                {canRegisterWarranty ? (
                    <div className="mt-5 flex flex-col items-start gap-1">
                        <a
                            className="inline-flex items-center justify-center gap-[8px] text-nowrap rounded-[6px] border border-primary-600 bg-primary-600 px-[16px] py-[10px] text-[14px] font-semibold leading-[14px] text-white no-underline shadow-sm shadow-[rgba(16,24,40,0.05)] transition-colors duration-200 hover:border-primary-700 hover:bg-primary-700"
                            href={warrantyUrl.toString()}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t("buttonLabel")}
                            <ArrowUpRightIcon strokeColor="white" />
                        </a>
                        <p className="text-[10px] leading-[18px] text-gray-400">{t("underButtonLabel")}</p>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
